import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-close\"><path d=\"M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18m0-19.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5\" /><path d=\"M15.595 7.345 12 10.94 8.405 7.345l-1.06 1.06L10.94 12l-3.595 3.595 1.06 1.06L12 13.06l3.595 3.595 1.06-1.06L13.06 12l3.595-3.595z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol